import { CartOrder, CartProfile } from 'cart-core';

export default abstract class SignUpAngularController {
  /**
   * The new profile that is being created
   */
  public newProfile: CartProfile = {
    signupReferrer: '', // Server validation requires this key to exist
  };

  /**
   * Order that describes the current sign-up
   */
  public order: CartOrder = {};

  /**
   * Whether the user has indicated they have a sponsor
   */
  public haveSponsor: boolean;

  /**
   * Sponsor RCN confirmation field
   */
  public sponsorRcnAgain: string = null;

  /**
   * Password confirmation field
   */
  public passwordAgain: string = null;

  /**
   * Returns whether or not the form should show the profile's primary fields
   */
  public abstract shouldShowProfilePrimaryFields(): boolean;

  /**
   * Returns whether or not the form should ask the user if they have a sponsor
   */
  public shouldAskIfHasSponsor() {
    return !!this.order.attributes && this.order.attributes.guestSignUpRules.enabled && !this.order.attributes.isPws;
  }

  /**
   * Returns whether or not the form should show the sponsor RCN fields
   */
  public abstract shouldShowSponsorRcn(): boolean;

  /**
   * Returns whether or not the form should verify the sponsor RCN
   */
  public shouldVerifySponsorRcn() {
    return this.shouldShowProfilePrimaryFields() && this.shouldAskIfHasSponsor() && this.shouldShowSponsorRcn();
  }

  /**
   * Verifies the sponsor RCN against the re-entry field.
   *
   * If the field fails to verify, the re-entry field will be highlighted.
   *
   * @return Whether the field was verified
   */
  public verifySponsorRcn() {
    if (!this.shouldVerifySponsorRcn()) {
      return true;
    }
    if (this.newProfile.sponsorRcn !== this.sponsorRcnAgain) {
      // TODO: Angular doesn't have a way to declaratively reference an
      // element from a controller, so we have to access it by query
      const el = document.querySelector<HTMLInputElement>('[name="sponsorRcnAgain"]');
      if (el && el.focus) {
        el.focus();
      }
      return false;
    }
    return true;
  }

  /**
   * Verifies the password against the re-entry field.
   *
   * If the field fails to verify, the re-entry field will be highlighted.
   *
   * @return Whether the field was verified
   */
  public verifyPassword() {
    if (!this.shouldShowProfilePrimaryFields()) {
      return true;
    }
    if (this.newProfile.password !== this.passwordAgain) {
      // TODO: Angular doesn't have a way to declaratively reference an
      // element from a controller, so we have to access it by query
      const el: HTMLInputElement = document.querySelector('[name="passwordAgain"]');
      if (el && el.focus) {
        el.focus();
      }
      return false;
    }
    return true;
  }
}
